<template>
<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4.16797 10H15.8346" stroke="#AC986A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

</template>